import styled from 'styled-components';

export const MainRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  min-height: ${({ theme }) => theme.spacing.km12};
`;

export const ButtonWrapper = styled.div`
  margin-left: auto;
`;

export const IconWrapper = styled.div`
  & > * {
    display: block;
  }
`;
